// extracted by mini-css-extract-plugin
export default {"main":"Background_main__gm9Mx","background":"Background_background__9uH7L","backgroundResponsive":"Background_backgroundResponsive__z-RNb","children":"Background_children__gFBxd"};